<template>
  <lu-hbox :class="{'hidden':hidden}" class="pagination-container">
    <el-tooltip class="item" :effect="styleTooltip" :content="$t('Delete all selected items')" placement="top" v-if='hasDelete'>
      <!-- <lu-item class='headerIcon el-icon-close text-red' style='margin-top:5px;' :class='hasDelete ? "lu-click" : "disabled"' @click.stop='handleDelete'></lu-item> -->
      <el-button size="mini" class='icon' icon="el-icon-delete icon success"  @click='handleDelete'/>
    </el-tooltip>

    <el-pagination
      class='lu-flex lu-hbox lu-hcenter'
      :background="background"
      :current-page.sync="currentPage"
      :page-size.sync="pageSize"
      :layout="layout"
      :page-sizes="pageSizes"
      :total="total"
      v-bind="$attrs"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"/>
  </lu-hbox>
</template>

<script>
import { mapGetters } from 'vuex'
import { LuHbox } from 'lusis-ui'
import { scrollTo } from '@/utils/scrollTo'

export default {
  name: 'Pagination',
  components: { LuHbox },
  props: {
    total: {
      required: true,
      type: Number
    },
    hasDelete: {
      type: Boolean,
      default: true
    },
    page: {
      type: Number,
      default: 1
    },
    limit: {
      type: Number,
      default: 0
    },
    pageSizes: {
      type: Array,
      default() {
        return [10, 20, 30, 50]
      }
    },
    layout: {
      type: String,
      default: 'total, sizes, prev, pager, next, jumper'
    },
    background: {
      type: Boolean,
      default: true
    },
    autoScroll: {
      type: Boolean,
      default: true
    },
    hidden: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['pageSize', 'theme']),
    styleTooltip: function () {
      return this.theme !== 'light-theme' ? 'dark' : 'light'
    },
    currentPage: {
      get() {
        return this.page
      },
      set(val) {
        this.$emit('update:page', val)
      }
    },
    pageSize: {
      get() {
        return this.limit
      },
      set(val) {
        this.$store.dispatch('app/setPageSize', val)
        this.$emit('update:limit', val)
      }
    }
  },
  methods: {
    handleSizeChange(val) {
      this.$emit('pagination', { page: this.currentPage, limit: val })
      if (this.autoScroll) {
        scrollTo(0, 800)
      }
    },
    handleCurrentChange(val) {
      this.$emit('pagination', { page: val, limit: this.pageSize })
      if (this.autoScroll) {
        scrollTo(0, 800)
      }
    },
    handleDelete() {
      this.$emit('deleteSelectedItem')
    }
  }
}
</script>

<style lang='scss' scoped>

.pagination-container {
  padding: 10px 16px;
}

.pagination-container.hidden {
  display: none;
}
</style>
